import { parse, format } from "date-fns";

export const DATE_FORMAT = "dd/MM/yyyy";
export const TIME_FORMAT = "HH:mm:ss";

export function formatDate(date: string | number) {
  return format(parse(String(date), "yyyyMMdd", new Date()), "dd/MM/yyyy");
}

export function formatDateAndTime(date: string | number, time: string | number) {
  const raw = String(date) + `0${String(time)}`.slice(-6);
  try {
    return format(parse(raw, "yyyyMMddHHmmss", new Date()), "dd/MM/yyyy HH:mm:ss");
  } catch (err) {
    console.error("Failed to format ", raw);
    console.error(err);
    return "Invalid Date";
  }
}

export function formatTimestamp(timestamp: number): { dateTime: string, date: string; time: string } {
  const dateTime = format(timestamp, "dd/MM/yyyy HH:mm:ss");
  const date = format(timestamp, "dd/MM/yyyy");
  const time = format(timestamp, "HH:mm:ss");
  return { dateTime, date, time };
}
